var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg"},[_c('ul',{staticClass:"course-list"},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.goPlanNum(
          item.totalTime,
          item.incompleteTime,
          item.finishTime,
          item.absentSTime
        )}}},[_c('label',[_vm._v(_vm._s(item.courseNm))]),_c('span',[_vm._v(_vm._s(item.incompleteTime)+"/"+_vm._s(item.totalTime))]),_c('van-icon',{attrs:{"name":"arrow"}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }